
export const textTrim = (text) => {
    const altTxt = text && text.replace(/[\u00A0\u1680\u180e\u2000-\u2009\u200a\u200b\u202f\u205f\u3000]/g, ' ').trim();
    return altTxt;
};



export const getFormattedMessage = (intl, messageObj) => {
    if (messageObj && typeof messageObj === 'string') {
        return intl.messages[messageObj] || '';
    }
    const message = intl.formatMessage(messageObj);
    return `${message !== messageObj.id ? message : ''}`;
};
